// ======================
// Core Imports
// ======================
import React from 'react';
import { Carousel } from 'react-bootstrap';

// ======================
// Image Assets
// ======================
import Slider1 from '../assets/images/rmc-pro-ready-mixed-concrete.png';
import Slider2 from '../assets/images/concrete-batching-plants.png';
import Slider3 from '../assets/images/concrete-mixes-supplier-rmc-pro.png';

// ======================
// Slider Component
// ======================
const Slider = () => {
  return (
    // Hide slider on extra-small devices (mobile)
    <div className="slider d-none d-sm-block">
      <Carousel controls={false} interval={5000} fade>

        {/* ===== Slide 1 ===== */}
        <Carousel.Item>
          <div className="slider-image-wrapper">
            <img 
              className="d-block w-100 slider-img" 
              src={Slider1} 
              alt="ready mix concrete delivery" 
            />
            <div className="slider-overlay" /> {/* Optional dark overlay */}
          </div>
          <Carousel.Caption className="carousal-text">
            <h2>Modern Ready Mix Concrete (RMC)</h2>
            <p className="mb-0">
              High-performance concrete manufactured in fully automated batching 
              plants to ensure superior strength, durability, and consistency.
            </p>
          </Carousel.Caption>
        </Carousel.Item>

        {/* ===== Slide 2 ===== */}
        <Carousel.Item>
          <div className="slider-image-wrapper">
            <img 
              className="d-block w-100 slider-img" 
              src={Slider2} 
              alt="batching plant in operation" 
            />
            <div className="slider-overlay" />
          </div>
          <Carousel.Caption>
           <h2>Advanced Concrete Manufacturing</h2>
            <p className="mb-0">
              Computerized batching systems with strict quality control 
              to meet national and international construction standards.
            </p>
          </Carousel.Caption>
        </Carousel.Item>

        {/* ===== Slide 3 ===== */}
        <Carousel.Item>
          <div className="slider-image-wrapper">
            <img 
              className="d-block w-100 slider-img" 
              src={Slider3} 
              alt="construction site with rmc" 
            />
            <div className="slider-overlay" />
          </div>
          <Carousel.Caption>
            <h2>Your Trusted RMC Partner</h2>
            <p className="mb-0">
              Timely delivery, customized mix designs, and dependable 
              service for residential, commercial, and infrastructure projects.
            </p>
          </Carousel.Caption>
        </Carousel.Item>

      </Carousel>
    </div>
  );
};

export default Slider;
